export default "__VITE_ASSET__DBg_01b8__"